import { WishlistDb } from '~/assets/ts/items/dao/wishlistDb'
import { WishlistAPI } from '~/assets/ts/items/dao/wishlistAPI'

export class Wishlist {
  indexDb: WishlistDb
  wishlistApi: WishlistAPI
  maxItems: number

  constructor() {
    this.indexDb = new WishlistDb()
    this.wishlistApi = new WishlistAPI()
    this.maxItems = 4
  }

  add(setSlug: string) {
    return new Promise((resolve) => {
      if (process.client && typeof window !== 'undefined') {
        const setIdParts: string[] = setSlug.split('_')[0].split('-')

        this.indexDb.openDb().then(() => {
          this.indexDb
            .put({
              set: setIdParts.join('-'),
              slug: setSlug,
              timestamp: Date.now(),
            })
            .then(() => {
              this.syncWithApi()
              resolve(true)
            })
        })
      }
    })
  }

  isOnWishlist(setSlug: string) {
    return new Promise((resolve) => {
      if (process.client && typeof window !== 'undefined') {
        this.indexDb.openDb().then(() => {
          this.indexDb.get(setSlug).then((data: any) => {
            resolve(typeof data !== 'undefined')
          })
        })
      }
    })
  }

  clear() {
    return new Promise((resolve) => {
      if (process.client && typeof window !== 'undefined') {
        this.indexDb.openDb().then(() => {
          this.indexDb.clear().then(() => {
            this.wishlistApi.delete()
            resolve(true)
          })
        })
      }
    })
  }

  remove(setSlug: string) {
    return new Promise((resolve) => {
      if (process.client && typeof window !== 'undefined') {
        this.indexDb.openDb().then(() => {
          this.indexDb.delete(setSlug).then(() => {
            this.syncWithApi()
            resolve(true)
          })
        })
      }
    })
  }

  syncWithApi() {
    if (process.client && typeof window !== 'undefined') {
      this.indexDb.openDb().then(() => {
        this.indexDb.getAll().then((result) => {
          this.wishlistApi.save(result)
        })
      })
    }
  }

  loadFromApi(wishlistId: string) {
    return new Promise((resolve, reject) => {
      this.wishlistApi
        .get(wishlistId)
        .then((listFromApi: any) => {
          this.wishlistApi.setWishlistId(wishlistId)
          this.indexDb.openDb().then(() => {
            this.indexDb.clear().then(() => {
              if (listFromApi.items.length === 0) {
                resolve(true)
              } else {
                for (const itemIdx in listFromApi.items) {
                  this.indexDb.put(listFromApi.items[itemIdx]).then(() => {
                    if (parseInt(itemIdx) + 1 === listFromApi.items.length) {
                      resolve(true)
                    }
                  })
                }
              }
            })
          })
        })
        .catch(() => {
          reject(new Error('failed'))
        })
    })
  }

  getList() {
    return new Promise((resolve) => {
      if (process.client && typeof window !== 'undefined') {
        this.indexDb.openDb().then(() => {
          this.indexDb.getAll().then((result) => {
            resolve(result as { [key: string]: string }[])
          })
        })
      } else {
        resolve(false)
      }
    })
  }

  getSlugList() {
    return new Promise((resolve) => {
      if (process.client && typeof window !== 'undefined') {
        this.getList().then((wishlistItems: any) => {
          const slugList: string[] = []

          for (const itemIdx in wishlistItems) {
            if (typeof wishlistItems[itemIdx].slug === 'string') {
              slugList.push(wishlistItems[itemIdx].slug)
            }
          }

          resolve(slugList)
        })
      }
    })
  }

  getCurrentWishlistId() {
    return this.wishlistApi.getWishlistId()
  }
}
